import {LeadEventApiDto, LeadQuoteDeletedEventDataApiDto} from "../../../api/model/rest";
import LeadEvent, {LeadEventTypeEnum} from "./LeadEvent";
import AuthenticatedEntity from "../../user/AuthenticatedEntity";
import moment = require("moment");
import {Icon} from "../../../hiberUiKit/src/atoms/Icon/Icon";
import {IconColor} from "../../../hiberUiKit/src/molecules/StreamItem/StreamItemIcon";

export default class LeadQuoteDeletedEvent extends LeadEvent {
	/**
	 * @param {string} id identifier of event.
	 * @param {string} leadId lead id.
	 * @param {LeadEventTypeEnum} type type of the event.
	 * @param {AuthenticatedEntity} entity entity which creates the event.
	 * @param {moment.Moment} creationDate creation date of event.
	 * @param {string} referenceNumber lead reference number.
	 * @param {LeadQuoteDeletedEventData} data deleted quote data
	 */
	constructor(public readonly id: string,
		public readonly leadId: string,
		public readonly type: LeadEventTypeEnum,
		public readonly entity: AuthenticatedEntity,
		public readonly creationDate: moment.Moment,
		public readonly referenceNumber: string,
		public readonly data: LeadQuoteDeletedEventData) {
		super(id, leadId, type, entity, creationDate, referenceNumber);
	}

	public static fromJson(json: LeadEventApiDto): LeadQuoteDeletedEvent {
		const data = LeadQuoteDeletedEventData.fromJson(json.data as LeadQuoteDeletedEventDataApiDto);
		const entity = AuthenticatedEntity.fromJson(json.entity);
		return new LeadQuoteDeletedEvent(json.id,
			json.leadId,
			LeadEventTypeEnum.QuoteDeleted,
			entity,
			moment(json.createdAt),
			json.referenceNumber,
			data);
	}

	getIcon() {
		return Icon.Quote;
	}

	getIconColor(): IconColor {
		return IconColor.Burgundy;
	}

	getActivityType(): string {
		return `QUOTE ${this.data.quoteNumber}`
	}

	getActivityMessage(): string {
		return `Quote deleted`;
	}

	getActivityAdditionalMessages(): string[] {
		return [this.data.jobTypeName]
	}
}

export class LeadQuoteDeletedEventData {
	constructor(public readonly quoteId: string,
		public readonly quoteNumber: number,
		public readonly jobTypeName: string,
		public readonly jobTypeId: string) {}

	public static fromJson(json: LeadQuoteDeletedEventDataApiDto): LeadQuoteDeletedEventData {
		return new LeadQuoteDeletedEventData(json.id, json.quoteNumber, json.jobTypeName, json.jobTypeId);
	}
}
